import React, { useMemo } from 'react';
import { useTranslate } from 'react-admin';
import CustomizedFilterWrapper from '../../../../base/components/customized/CustomizedFilterWrapper';
import { SelectInput, TextInput } from '../../../../base/components/ra/inputs';
import { isSystemUsers } from '../../../../services/util/auth';
import { INVOICE_STATUS, PAYMENT_STATUS } from '../../../../constant/invoice';
import GroupSelector from '../../../../base/components/customized/common-input/GroupSelector';
import { useAuthUser } from '../../../../base/hooks';
import DateRangeInput from '../../../../base/components/guesser/date-range-input';

const PaymentFilters = () => {
  const t = useTranslate();
  const isSU = isSystemUsers();

  const paymentStatusChoices = useMemo(
    () =>
      Object.values(PAYMENT_STATUS).reduce((list, status) => {
        if (isSU || status !== PAYMENT_STATUS.WAIVED) {
          list.push({
            id: status,
            name: t(`common.paymentStatus.${status}`),
          });
        }
        return list;
      }, []),
    [t],
  );

  const invoiceStatusChoices = useMemo(
    () =>
      Object.values(INVOICE_STATUS).reduce((list, status) => {
        if (isSU || status !== INVOICE_STATUS.OPEN) {
          list.push({
            id: status,
            name: t(`common.invoiceStatus.${status}`),
          });
        }
        return list;
      }, []),
    [t],
  );

  return (
    <CustomizedFilterWrapper>
      <GroupFilter />
      <TextInput source="invoiceNo||$eq" label="resources.invoice.fields.invoiceNo" />
      <DateRangeInput
        source="invoiceDate"
        label={t('resources.invoice.fields.invoiceDate')}
        defaultRangeOption="date"
        hasRangeOption={false}
        showTime={false}
        allowClear={[true, true]}
        allowEmpty={[true, true]}
        ranges={[]}
        serverFormat={null}
      />
      <SelectInput source="paymentStatus" label="resources.payment.fields.status" choices={paymentStatusChoices} />
      <SelectInput source="invoiceStatus" label="resources.invoice.fields.status" choices={invoiceStatusChoices} />
    </CustomizedFilterWrapper>
  );
};

export default PaymentFilters;

const GroupFilter = () => {
  const user = useAuthUser();
  const userGroupId = user.group?.id;

  return <GroupSelector source="groupId" defaultValue={userGroupId} disabled={Boolean(userGroupId)} />;
};
